import { Controller } from "react-hook-form";
import { BaseField } from "./BaseField";
import { FieldProps } from "modules/record/record-producer/types/record-producer-types";
import Translate from "component/global/translation/translation-component";
import { useChoiceOptions } from "modules/record/shared/hooks/useChoiceOptions";
import { ChoiceAutocompleteInput } from "modules/record/shared/components/ChoiceAutocompleteInput";
import { buildRequiredRule, getRequiredFieldMessage } from "../../services/recordProducerValidation";
import { getFieldHelperText } from "../../services/fieldHelperText";
import { useTranslation } from "react-i18next";
import { translateMetadataLabel } from "modules/record/shared/services/recordMetadataLabels";

export const ChoiceFieldComponent = ({ column, control, baseFieldProps, runtimeProps }: FieldProps) => {
    const { t } = useTranslation();
    const {
        data: choices = [],
        isLoading
    } = useChoiceOptions(column);

    if (!choices && !isLoading) {
        return (
            <Translate text="It was not possible to load 'Choice' field..." />
        );
    }

    return (
        <BaseField column={column} required={runtimeProps?.required} hidden={runtimeProps?.hidden} {...baseFieldProps}>
            <Controller
                name={column.name}
                control={control}
                defaultValue={column.default_value ?? null}
                rules={{ required: buildRequiredRule(runtimeProps?.required ?? column.is_mandatory, getRequiredFieldMessage(column)) }}
                render={({ field, fieldState }) => {
                    return (
                        <ChoiceAutocompleteInput
                            options={choices}
                            loading={isLoading}
                            value={field.value}
                            onChange={field.onChange}
                            disabled={runtimeProps?.readonly}
                            error={!!fieldState.error}
                            helperText={getFieldHelperText(fieldState, runtimeProps)}
                            required={runtimeProps?.required ?? column.is_mandatory}
                            fieldLabel={translateMetadataLabel(t, column)}
                            columnTypePicker={column.name === "column_type"}
                        />
                    );
                }}
            />
        </BaseField>
    );
};
